<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">

                <div class="header-block">
                    <div class="header-title">
                        <p>Customer Info List</p>
                    </div>
                    <div class="add-block">
                        <div class="search">
                            <input type="text" placeholder="search" name="" id="">
                            <i class="bi bi-search"></i>
                        </div>
                        <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
                    </div>
                </div>
              
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 20%;">Name</th>
                            <th style="width: 20%;">EmailId</th>
                            <th style="width: 20%;">Mobile</th>
                            <th style="width: 15%;">Service</th>
                            <th style="width: 15%;">Status</th>
                            <th style="width: 10%;">Action</th>
                        </tr>
                    </thead>
                </table>
                <div class="data-view" *ngFor="let customer of customerInfo | paginate : {
                    itemsPerPage: tableSize,
                    currentPage: pageNumber,
                    totalItems: totalRecords
                    }  ;let i = index">

                    <p style="width: 20%;" title="{{customer.name}}">{{customer.name}}</p>
                    <p style="width: 20%;" title="{{customer.emailId}}">{{customer.emailId}}</p>
                    <p style="width: 20%;" title="{{customer.mobileNo1}}">{{customer.mobileNo1}} </p>
                    <p style="width: 15%;">{{customer.serviceName}}</p>
                    <p style="width: 15%;">{{customer.latestStatus}}</p>
                    <p style="width: 10%;align-items: center;display: flex;justify-content: center;">
                        <svg xmlns="http://www.w3.org/2000/svg" (click)="getCustomerInfoById(customer.customerInfoId)" data-toggle="modal" data-target="#exampleModalView"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                            <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                            <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg> 
                    </p>
                </div>
   

                <div class="paginator">
                    <p-paginator (onPageChange)="onPageChange3($event)" [first]="first3" [rows]="rows3" [totalRecords]="totalRecords"
                        [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
                </div>
            </div>
        </div>
    </div>
</div>
  
   
<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Add Customer
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div [formGroup]="form">
                    <div class="row">
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>Name</label>
                                <input formControlName="name" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>Email</label>
                                <input formControlName="emailId" type="email" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>Mobile No1</label>
                                <input formControlName="mobileNo1" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>Mobile No2</label>
                                <input formControlName="mobileNo2" type="text" class="form-control">
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>Description</label>
                                <textarea class="form-control" formControlName="description" name="" id="" cols="5" rows="5"></textarea>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>Address</label>
                                <textarea class="form-control" formControlName="address" name="" id="" cols="5" rows="5"></textarea>
                            </div>
                        </div>
                        <div class="col-md-6 col-lg-6">
                            <div class="form-group">
                                <label>Service Name</label>
                                <select class="form-control" aria-label="Default select example" formControlName="serviceName">
                                  <option [value]="service.name" *ngFor="let service of serviceData">{{service.name}}</option>
                                </select>
                            </div>
                          </div>
                        <div class="col-md-6 col-lg-6" *ngFor="let param of paramData">
                            <div class="form-group">
                                <label>{{param.name}}</label>
                                <select [ngModelOptions]="{standalone: true}" *ngIf="param.possibleValue.length != 0" name="" id="" class="form-control" [(ngModel)]="param.value">
                                    <option [value]="possibleValue" *ngFor="let possibleValue of param.possibleValue">{{possibleValue}}</option>
                                </select>
                                <input [ngModelOptions]="{standalone: true}" *ngIf="param.possibleValue.length == 0" type="text" class="form-control" [(ngModel)]="param.value">
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12">
                            <div class="form-group">
                                <label>Image</label>
                                <input type="file" accept="image/*" (change)="onChange($event)">
                            </div>
                        </div>
                        <!-- <div class="col-md-5 col-lg-5" [hidden]="true">
                            <div class="form-group">
                                <input type="file" id="add-doc-btn" (change)="onChange($event)" />
                            </div>
                        </div>
                        <div class="col-md-5 col-lg-5">
                            <div class="form-group">
                                <label>Document</label>
                                <div *ngFor="let doc of documents">
                                    <p>{{doc}}</p>
                                </div>
                                <button (click)="addDocBtn()">Add document</button>
                            </div>
                        </div> -->

                        
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <button type="button" (click)="addCustomer()" *ngIf="buttonDisable == false" class="btn btn-primary">Add Customer</button>
                </div>
            </div>
        </div>
    </div>
</div>
  


<div class="modal fade" id="exampleModalView" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Customer Info Details
                    <span data-dismiss="modal">
                        <i class="bi bi-x-lg"></i>
                    </span>
                </h5>
            </div>
            <div class="modal-body" *ngFor="let customer of singleCustomerInfo;let i =index">
                <div class="row view" >
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Name</label>
                            <!-- <input type="text" value="{{customer.name}}" class="form-control"> -->
                            <p *ngIf="customer.name != null && customer.name != ''">{{customer.name}}</p>
                            <p *ngIf="customer.name == null || customer.name == ''">--</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Email</label>
                            <!-- <input type="email" value="{{customer.emailId}}" class="form-control"> -->
                            <p *ngIf="customer.emailId != null && customer.emailId != ''">{{customer.emailId}}</p>
                            <p *ngIf="customer.emailId == null || customer.emailId == ''">--</p>

                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Service</label>
                            <!-- <input type="email" value="{{customer.emailId}}" class="form-control"> -->
                            <p *ngIf="customer.serviceName != null && customer.serviceName != ''">{{customer.serviceName}}</p>
                            <p *ngIf="customer.serviceName == null || customer.serviceName == ''">--</p>

                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Mobile No1</label>
                            <!-- <input type="text" value="{{customer.mobileNo1}}" class="form-control"> -->
                            <p *ngIf="customer.mobileNo1 != null && customer.mobileNo1 != ''">{{customer.mobileNo1}}</p>
                            <p *ngIf="customer.mobileNo1 == null || customer.mobileNo1 == ''">--</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Mobile No2</label>
                            <!-- <input type="text" value="{{customer.mobileNo2}}" class="form-control"> -->
                            <p *ngIf="customer.mobileNo2 != null && customer.mobileNo2 != ''">{{customer.mobileNo2}}</p>
                            <p *ngIf="customer.mobileNo2 == null || customer.mobileNo2 == ''">--</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Description</label>
                            <!-- <textarea class="form-control" value="{{customer.description}}" name="" id="" cols="30" rows="10"></textarea> -->
                            <p *ngIf="customer.description != null && customer.description != ''">{{customer.description}}</p>
                            <p *ngIf="customer.description == null || customer.description == ''">--</p>
                        </div>
                    </div>
                    <div class="col-md-6 col-lg-6">
                        <div class="form-group">
                            <label>Address</label>
                            <!-- <textarea class="form-control" value="{{customer.address}}" name="" id="" cols="30" rows="10"></textarea> -->
                            <p *ngIf="customer.address != null && customer.address != ''">{{customer.address}}</p>
                            <p *ngIf="customer.address == null || customer.address == ''">--</p>
                        </div>
                    </div>

                    <div class="col-md-6 col-lg-6" *ngFor="let params of customer.customerParamEntityList">
                        <div class="form-group">
                            <label for="">{{params.key}}</label>
                            <p>{{params.value}}</p>
                            <p *ngIf="params.value != null && params.value != ''">{{params.value}}</p>
                            <p *ngIf="params.value == null || params.value == ''">--</p>
                        </div>
                    </div>

                    <div class="image-container" *ngIf="customer.image != null && customer.image != '' && customer.image != undefined && customer.image != 'string'">
                        <div class="image-header">
                            <h5>Images</h5>
                        </div>
                        <div class="image-content-block">
                            <div class="image-single">
                                <a href="{{customer.image}}" download><img src="{{customer.image}}" alt=""></a>
                            </div>
                        </div>
                    </div>
                    <div class="image-container" *ngIf="customer.documents != null && customer.documents != '' && customer.documents != undefined && customer.documents != 'string'">
                        <div class="image-header">
                            <h5>Documents</h5>
                        </div>
                        <div class="image-content-block">
                            <div class="image-single" *ngFor="let doc of doc">
                                <a *ngIf="doc.type == 'image'" href="{{doc}}" download><img src="{{doc.url}}" download alt=""></a>
                                <a *ngIf="doc.type == 'doc'" href="{{doc.url}}" download><p><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-earmark-pdf-fill" viewBox="0 0 16 16">
                                    <path d="M5.523 12.424c.14-.082.293-.162.459-.238a7.878 7.878 0 0 1-.45.606c-.28.337-.498.516-.635.572a.266.266 0 0 1-.035.012.282.282 0 0 1-.026-.044c-.056-.11-.054-.216.04-.36.106-.165.319-.354.647-.548zm2.455-1.647c-.119.025-.237.05-.356.078a21.148 21.148 0 0 0 .5-1.05 12.045 12.045 0 0 0 .51.858c-.217.032-.436.07-.654.114zm2.525.939a3.881 3.881 0 0 1-.435-.41c.228.005.434.022.612.054.317.057.466.147.518.209a.095.095 0 0 1 .026.064.436.436 0 0 1-.06.2.307.307 0 0 1-.094.124.107.107 0 0 1-.069.015c-.09-.003-.258-.066-.498-.256zM8.278 6.97c-.04.244-.108.524-.2.829a4.86 4.86 0 0 1-.089-.346c-.076-.353-.087-.63-.046-.822.038-.177.11-.248.196-.283a.517.517 0 0 1 .145-.04c.013.03.028.092.032.198.005.122-.007.277-.038.465z"/>
                                    <path fill-rule="evenodd" d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2zm5.5 1.5v2a1 1 0 0 0 1 1h2l-3-3zM4.165 13.668c.09.18.23.343.438.419.207.075.412.04.58-.03.318-.13.635-.436.926-.786.333-.401.683-.927 1.021-1.51a11.651 11.651 0 0 1 1.997-.406c.3.383.61.713.91.95.28.22.603.403.934.417a.856.856 0 0 0 .51-.138c.155-.101.27-.247.354-.416.09-.181.145-.37.138-.563a.844.844 0 0 0-.2-.518c-.226-.27-.596-.4-.96-.465a5.76 5.76 0 0 0-1.335-.05 10.954 10.954 0 0 1-.98-1.686c.25-.66.437-1.284.52-1.794.036-.218.055-.426.048-.614a1.238 1.238 0 0 0-.127-.538.7.7 0 0 0-.477-.365c-.202-.043-.41 0-.601.077-.377.15-.576.47-.651.823-.073.34-.04.736.046 1.136.088.406.238.848.43 1.295a19.697 19.697 0 0 1-1.062 2.227 7.662 7.662 0 0 0-1.482.645c-.37.22-.699.48-.897.787-.21.326-.275.714-.08 1.103z"/>
                                </svg>
                                document
                                </p></a>
                            </div>
                        </div>
                    </div>
              

                </div>
                <div class="modal-footer">
                    <!-- <button type="button" id="closeModalButton" *ngIf="customer.latestStatus != 'REJECTED' && customer.latestStatus != 'APPROVED'" class="btn btn-danger left" (click)="rejectCustomerInfo()" >reject</button> -->
                    <button type="button" id="closeModalButton4"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <!-- <button type="button" id="closeModalButton" *ngIf="customer.latestStatus != 'APPROVED' && customer.latestStatus != 'REJECTED'"  class="btn btn-primary" (click)="approveCustomerInfo()" >Approve</button> -->
                </div>
            </div>
        </div>
    </div>
</div>



<div class="modal fade" id="imageView" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="task-content">
                <div class="c-button">
                    <div style="align-items: center;">
                        <span data-dismiss="modal">
                            <i class="bi bi-x-lg"></i>
                          </span>
                    </div>
                </div>
                <div class="" style="display: flex;justify-content: center;align-items: center;height: 600px;">
                    <img *ngIf="SingleDocument != ''" width="300px" height="300px" src="{{SingleDocument}}" alt="">
                </div>
            </div>
        </div>
    </div>
</div>

<!-- <div class="modal fade" id="imageView" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content">
        <div class="task-content">
          <div class="c-button">
            <div style="align-items: center;">
              <svg xmlns="http://www.w3.org/2000/svg" style="margin-left: 10px" data-dismiss="modal" width="26" height="26" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </div>
          </div>
          <div class="" style="display: flex;justify-content: center;align-items: center;height: 600px;">
             <pdf-viewer
             [src]="this.PdfSrc"
             [render-text]="true"
             style="display:block">
             </pdf-viewer>
          </div>
        </div>
      </div>
    </div>
</div> -->




<div class="modal fade" id="exampleModalView" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Customer Info Details
                    <span data-dismiss="modal">
                        <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                            <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
                        </svg>
                    </span>
                </h5>
            </div>
            <div class="modal-body">
                <div>
                    
                </div>
                <div class="modal-footer">
                    <!-- <button type="button" id="closeModalButton" *ngIf="customer.latestStatus != 'REJECTED' && customer.latestStatus != 'APPROVED'" class="btn btn-danger left" (click)="rejectCustomerInfo()" >reject</button> -->
                    <button type="button" id="closeModalButton4"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
                    <!-- <button type="button" id="closeModalButton" *ngIf="customer.latestStatus != 'APPROVED' && customer.latestStatus != 'REJECTED'"  class="btn btn-primary" (click)="approveCustomerInfo()" >Approve</button> -->
                </div>
            </div>
        </div>
    </div>
</div>